import React from "react";

import SectionHeading from "@/components/Organisms/SectionHeading";
import WebinarCard from "./WebinarCard";
import Pagination from "@/components/Organisms/Pagination";
import usePagination from "@/hooks/usePagination";

import { Container, Wrapper, WebinarList, Div } from "./style";

function WatchPastWebinars({
  pastWebinarRef,
  data,
  onShowModalClick,
  isRegisteredUser,
  urlParams,
  handleScrollToPastWebinar,
  isWebinarRecordingsPage,
}) {
  const { sectionHeading, sectionHeadingColor, pastWebinarList } = data;

  let currentPageNo = parseInt(new URLSearchParams(urlParams).get("page"), 10);

  const {
    pages,
    pageNo,
    setPageNo,
    totalPages,
    currentPageData,
    isPerviousPage,
    isNextPage,
  } = usePagination({
    initialState: {
      page: currentPageNo,
      perPage: isWebinarRecordingsPage ? 3 : 4,
    },
    data: pastWebinarList,
  });

  const handlePageChange = (_pageNo) => {
    if (_pageNo !== pageNo) {
      handleScrollToPastWebinar();
      setPageNo(_pageNo);
    }
  };

  return (
    <Wrapper ref={pastWebinarRef}>
      <Container>
        <Div flexDirection="column">
          <SectionHeading
            title={sectionHeading}
            color={sectionHeadingColor}
            mb="32px"
          />
          <WebinarList>
            {currentPageData?.map((webinar, index) => (
              <WebinarCard
                key={`${webinar.title}-${index}`}
                onShowModalClick={onShowModalClick}
                isRegisteredUser={isRegisteredUser}
                isWebinarRecordingsPage={isWebinarRecordingsPage}
                {...webinar}
              />
            ))}
          </WebinarList>
          {!isWebinarRecordingsPage && totalPages > 1 && (
            <Pagination
              pageNo={pageNo}
              setPageNo={handlePageChange}
              isPerviousPage={isPerviousPage}
              isNextPage={isNextPage}
              totalPages={totalPages}
              pages={pages}
            />
          )}
        </Div>
      </Container>
    </Wrapper>
  );
}

WatchPastWebinars.propTypes = {};

WatchPastWebinars.defaultProps = {};

export default WatchPastWebinars;
